import { t } from "@lingui/macro";
import * as React from "react";
import { Rect, Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CrownIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 24 24" title={t`Crown`} {...props}>
    <Rect width={24} height={24} y={0.5} fill="#ACE5CF" rx={6} />
    <Path
      fill="#001A19"
      d="M19.133 11.727c-.287-.318-.781-.435-1.615.372-1.11 1.076-1.59 1.437-2.27 1.45-.811.014-1.543-.48-1.874-1.224-.223-.503-.463-1.206-.632-2.145-.049-.269-.21-.512-.46-.624A.611.611 0 0 0 12 9.5a.635.635 0 0 0-.283.055c-.25.112-.41.355-.459.624-.25 1.386-.67 2.266-.957 2.743a1.362 1.362 0 0 1-.886.633c-.793.164-1.585-.15-2.933-1.457-.834-.807-1.328-.69-1.615-.372-.32.356-.339.892-.125 1.319l.987 1.976a.8.8 0 0 0 .716.442h11.113a.8.8 0 0 0 .715-.442l.988-1.976c.213-.43.192-.963-.128-1.319Z"
    />
  </Icon>
);
